import React, {useState, useEffect, useRef} from "react";
import moment from "moment";
import {DateRangePicker} from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css"; 
import CalendarIcon from "../../assets/icons/calendar.png";

const DateRangePickerComponent = ({ 
    initialStartDate = moment().subtract(6, 'days').format('YYYY-MM-DD'),
    initialEndDate = moment().format('YYYY-MM-DD'),
    ranges = {
        "Last 24 Hours": [moment().subtract(1, 'day'), moment()],
        "Last 7 Days": [moment().subtract(6, 'days'), moment()],
        "This Month": [moment().startOf('month'), moment().endOf('month')],
        "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        "Last 90 Days": [moment().subtract(89, 'days'), moment()],
    },
    onDateRangeChange,
    style = {},
    className = ""
    }) => {
        const [start, setStart] = useState(initialStartDate);
        const [end, setEnd] = useState(initialEndDate);
        const [rangeDisplay, setRangeDisplay] = useState("");  
        
        const dateRangePickerRef = useRef(null);
        
        useEffect(() => {
            setStart(initialStartDate);
            setEnd(initialEndDate);
        }, [initialStartDate, initialEndDate]);

        useEffect(() => {
            setRangeDisplay(`${moment(start).format('MMMM D, YYYY')} - ${moment(end).format('MMMM D, YYYY')}`);
        }, [start, end]);

        useEffect(() => {
            if (dateRangePickerRef.current) {
              
                (dateRangePickerRef.current).data('daterangepicker').minDate = moment("2022-01-01");
                (dateRangePickerRef.current).data('daterangepicker').maxDate = moment();
            }
        }, []);

        
        const handleCallback = (startMoment, endMoment) => {
            const startDate = startMoment.format('YYYY-MM-DD');
            const endDate = endMoment.format('YYYY-MM-DD');

            setStart(startDate);
            setEnd(endDate);

            if (onDateRangeChange) {
                onDateRangeChange(startDate, endDate);
            }
        }

    return (
        <div 
            id="reportrange" 
            style={{ 
                borderRadius: "5px", fontSize: 13, color: "#3333CFCE", background: "#fff",
                cursor: "pointer", padding: "5px 7.5px", border: "1px solid #7A78F7", 
                width: "fit-content", display: "flex", alignItems: "center", height: "fit-content",
                ...style
            }}
            className={className}
        >
            <img src={CalendarIcon} alt="calendar-icon" style={{width: "15px", height: "15px", marginRight: "10px"}} />

            <DateRangePicker
                key={`${start}-${end}`}
                initialSettings={{
                    startDate: moment(start, 'YYYY-MM-DD'),
                    endDate: moment(end, 'YYYY-MM-DD'),
                    minDate: moment("2022-01-01"),
                    maxDate: moment(),
                    ranges
                }}
                onCallback={handleCallback}
            >
                <div>
                    <span>{rangeDisplay}</span>
                </div>
            </DateRangePicker>
        </div>
    )
}

export default DateRangePickerComponent